import React from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';

const CatDetails = ({ cats }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const cat = cats.find(c => c.id === id);

  if (!cat) {
    return (
      <div className="form-container">
        <h1>Cat Not Found</h1>
        <p>The cat you're looking for doesn't exist.</p>
        <button className="btn btn-primary" onClick={() => navigate('/')}>
          Back to Home
        </button>
      </div>
    );
  }

  return (
    <div className="cat-details-container">
      <h1>Cat Details</h1>
      <div className="cat-details">
        <img 
          src={cat.photo || 'https://api.images.cat/300/300/03276630-740c-47dc-8f85-82ca3aa82289'} 
          alt={cat.name}
          className="cat-details-photo"
        />
        <div className="cat-details-info">
          <h2>{cat.name}</h2>
          <div className="detail-item">
            <strong>Age:</strong> {cat.age} years old
          </div>
          <div className="detail-item">
            <strong>Breed:</strong> {cat.breed}
          </div>
          <div className="detail-item">
            <strong>Color:</strong> {cat.color}
          </div>
          {cat.personality && (
            <div className="detail-item">
              <strong>Personality:</strong> {cat.personality}
            </div>
          )}
          <div className="detail-actions">
            <Link to={`/edit/${cat.id}`} className="btn btn-primary">
              Edit Cat
            </Link>
            <button 
              className="btn btn-secondary" 
              onClick={() => navigate('/')}
            >
              Back to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CatDetails;
